export default __webpack_public_path__ + "static/media/avatar-gpt-demo.85115e44.png";